<template>
  <div class="neworder">
        <div class="neworder__title">
            <h1>Оформления заказа</h1>
        </div>
        <div v-if="CART.length != 0" class="neworder_margin">
            <div class="neworder_margin_l">
                <div 
                    class="neworder_margin_l_product"
                    v-for="item in CART"
                    :key="item.id"
                >
                    <div class="neworder_margin_l_product_img">
                      <img
                          v-if="item.img"
                          :src="'https://ecodom04.com/backend/'+ item.img"
                          alt="images"
                      >
                      <img
                          v-if="!item.img"
                          src="../assets/not_found.png"
                          alt="images"
                      >
                    </div>
                    <div class="neworder_margin_l_product_text">
                        <h4>{{item.title}}</h4>
                        <p>
                            <b>{{item.price | numeral('0,0')}}</b> ₸
                        </p>
                        <p>
                            Количество <b>{{item.quantity}}</b> 
                        </p>
                    </div>
                </div>
            </div>
            <div class="neworder_margin_r">
                <div class="neworder_margin_r_form">
                    <input type="text" autocomplete="off" v-model.trim="fio" placeholder="ФИО">
                    <div class="errorText"  v-if="$v.fio.$dirty && !$v.fio.required">Поле ФИО обязателен к заполнению</div>
                   
                    <select v-model.trim="city_id">
                        <option value="" :disabled="isDis">Выберите город</option>
                        <option
                            v-for="cityArrId in cityArr"
                            :key="cityArrId.id"
                            :value="cityArrId.id"
                        >
                            {{cityArrId.name}}
                        </option>
                    </select>
                    <div class="errorText" v-if="$v.city_id.$dirty && !$v.city_id.required">Поле Город обязателен к заполнению</div>

                    <select v-show="vue_type == true" v-model.trim="post_id">
                        <option value="" :disabled="isDis" selected>Почтовое отделение</option>
                        <option 
                            v-for="postArrId in postArr"
                            :key="postArrId.id"
                            :value="postArrId.id"
                        >
                            {{postArrId.name}}
                        </option>
                    </select>

                    <select v-model.trim="delivery_type" @change="viewTypeOrder">
                        <option value="" :disabled="isDis" selected>Тип доставки</option>
                        <option 
                            v-for="deliveryArrId in deliveryArr"
                            :key="deliveryArrId.id"
                            :value="deliveryArrId.id"
                        >
                            {{deliveryArrId.name}}
                        </option>
                    </select>
                    <div class="errorText" v-if="$v.delivery_type.$dirty && !$v.delivery_type.required">Поле Тип доставки обязателен к заполнению</div>

                    <textarea autocomplete="off" v-model.trim="comments" placeholder="Комментарии (не обязательно)"></textarea>
                    
                    <div class="bonuses_views" v-if="personal_discount == null || personal_discount == 0">
                        <p>
                            Общая сумма заказа 
                            <b v-show="mainPrice == ''">{{cartTotalPrice | numeral('0,0')}}</b> 
                            <b v-show="mainPrice != ''">{{this.mainPrice | numeral('0,0')}}</b> 
                            ₸
                        </p>
                        <p>
                            Бонусы к начислению  
                            <b v-show="accrualsBonus == ''">{{parseInt(cartTotalPrice * 0.05) | numeral('0,0')}}</b> 
                            <b v-show="accrualsBonus != ''">{{this.accrualsBonus | numeral('0,0')}}</b> 
                            ₸
                        </p>
                        <p>
                            Бонусы
                            <b>{{this.bonuses | numeral('0,0')}}</b> 
                            ₸
                        </p>
                        <input type="number" placeholder="0" v-model.trim="bonus_price_value" @input="bonus_price" @change="bonus_price">
                        <div class="errorText" v-if="$v.bonus_price_value.$dirty && !$v.bonus_price_value.required">Поле Бонус обязателен к заполнению</div>
                        <div class="errorText" v-if="!$v.bonus_price_value.numeric">Поле Бонус введите только цифры</div>
                        
                        <p class="error" v-show="showErrorBonus">Оплата с помощью бонусов не должна превышать 50% от общей суммы заказа</p>
                    </div>

                    <div class="discount_views" v-if="personal_discount != null && personal_discount != 0">
                        <p>
                            Общая сумма заказа 
                            <b>{{cartTotalPrice}}</b> 
                            ₸
                        </p>
                        <p v-if="personal_discount != null">
                            Персональная скидка: 
                            <b v-show="personal_discount != null">{{this.personal_discount}}</b>
                            <b v-show="personal_discount == null">0</b> 
                            % 
                        </p>
                        <p>
                            Итоговая цена 
                            <b>{{totalDiscontPrice}}</b> 
                            ₸   
                        </p>
                    </div>                
                    
                    <button @click="newOrderGet">
                        
                        <span v-show="!viewLoader">
                            оформить заказ
                        </span>
                        <v-progress-circular v-show="viewLoader" class="loader__color" indeterminate size="24"></v-progress-circular>
                    </button>
                </div>
            </div>
        </div>
        <div v-if="CART.length == 0" class="order_clear">
            <p>
                У вас нет товаров <router-link to="/" tag="a">перейти к покупкам</router-link>
            </p>
        </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from 'axios'
import { required, numeric } from 'vuelidate/lib/validators'

export default {
  name: 'neworder',
  components: {
  },
  data () {
      return {
         isDis: true,
         city_id: '',
         post_id: '',
         comments: '',
         delivery_type: '',
         fio: '',
         bonuses: '',
         personal_discount: '',
         cityArr: [],
         postArr: [],
         deliveryArr: [],
         mainPrice: '',
         bonus_price_value: '0',
         showErrorBonus: false,
         accrualsBonus: '',
         sendProductData: [],
         viewLoader: false,
         vue_type: false,
         user_data_city: '',
         user_data_delivery: '',
         user_data_post: '',
      }
  },
  validations: {
      fio: {
          required,
      },
      city_id: {
          required
      },
      delivery_type: {
          required
      },
      bonus_price_value: {
          required, numeric
      },
  },
  methods: {
     bonus_price() {
        let price = parseInt(this.cartTotalPrice / 2)
        if (this.bonus_price_value > price) {
            this.showErrorBonus = true
            this.bonus_price_value = ''
            this.mainPrice = ''
            this.accrualsBonus = ''
        } else {
            this.showErrorBonus = false
            this.mainPrice = this.cartTotalPrice - this.bonus_price_value
            let cartTotalPrice = this.cartTotalPrice - this.bonus_price_value
            this.accrualsBonus = parseInt(cartTotalPrice * 0.05)
        }
     },
     getUser() {
        axios({
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            url: this.$apiURI + 'public/user/get',
            data: {
                token: this.USER[0]
            }
        })
        .then((response) => {
            this.fio = response.data.fio
            this.user_data_city = response.data.city
            this.user_data_delivery = response.data.delivery
            this.user_data_post = response.data.post
            this.bonuses = response.data.bonuses
            this.personal_discount = response.data.personal_discount
        })
        .catch((error) => {
            console.log(error);
        });
     },
     getCity() {
        axios({
          method: 'get',
          url: this.$apiURI + 'public/city/getall',
        })
        .then((response) => {
            this.cityArr = response.data
        });
     },
     getPost() {
        axios({
          method: 'get',
          url: this.$apiURI + 'public/post/getall',
        })
        .then((response) => {
            this.postArr = response.data
        }); 
     },
     getDelivery() {
        axios({
          method: 'get',
          url: this.$apiURI + 'public/delivery/getall',
        })
        .then((response) => {
            this.deliveryArr = response.data
        }); 
     },
     getProducts() {
         this.CART.map(item => {
             let product = {
                 product_id: item.id,
                 product_count: item.quantity
             }
             this.sendProductData.push(product)
         })
     },
     viewTypeOrder () {
        if (this.delivery_type == 1) {
            this.vue_type = true
        } else if (this.delivery_type == 2) {
            this.vue_type = false
        }
     },
     newOrderGet () {
        if (this.$v.$invalid) {
            this.$v.$touch()
            return 
        } else {
            this.viewLoader = true
            let dataUser = {
                fio: this.fio,
                comment: this.comments,
                bonuses: this.bonus_price_value,
                city_id: this.city_id,
                post_id: this.post_id,
                delivery_type: this.delivery_type
            }
            axios({
                method: 'post',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                url: this.$apiURI + 'public/order/create',
                data: {
                    token: this.USER[0],
                    data: JSON.stringify(dataUser),
                    product_data: JSON.stringify(this.sendProductData)
                }
            })
            .then((response) => {
                this.viewLoader = false
                this.fio = ''
                this.comments = ''
                this.bonus_price_value = '0'
                window.open(response.data.url)
            })
            .catch((error) => {
                console.log(error);
            });
        }
    },

    setCity () {
      this.city_id = this.cityArr.filter(city => {
          if (city.name === this.user_data_city)
            return city
        })[0].id || '';
    },
    setDelivery () {
      this.delivery_type = this.deliveryArr.filter(type => {
          if (type.name === this.user_data_delivery)
            return type
        })[0].id || '';
    },
    setPost () {
      this.post_id = this.postArr.filter(type => {
          if (type.name === this.user_data_post)
            return type
        })[0].id || '';

      if (this.post_id !== '') {
        this.vue_type = true;
      }
    },
  },
  mounted() {
    this.getCity()
    this.getDelivery()
    this.getPost()
    this.getProducts()
    this.getUser()
  },
  computed: {
    ...mapGetters(['CART', 'USER']),
    totalDiscontPrice() {
        let discountPercent = this.personal_discount / 100
        let discountSum = parseInt(this.cartTotalPrice * discountPercent)
        let totalDiscountPrice = parseInt(this.cartTotalPrice - discountSum)
        return totalDiscountPrice
    },
    cartTotalPrice() {
        let total = 0;
        for (let item of this.CART) {
            total += item.price;
        }
        return total;
    }
  },
  watch: {
    user_data_city: function (val) {
      this.setCity(val);
    },
    user_data_delivery: function (val) {
      this.setDelivery(val);
    },
    user_data_post: function (val) {
      this.setPost(val);
    },
  }
}
</script>
<style scoped lang="less">
@baseMedia: 900px;

.neworder {
    width: 1200px;
    margin: 0 auto;
    background: white;
    @media (max-width: @baseMedia) {
        width: 95%;
        justify-content: center;
        flex-wrap: wrap;
    }
    .order_clear {
        width: 100%;
        height: 50vh;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        p {
            color: #000;
            font-size: 30px;
            a {
                color: #000;
            }
            @media (max-width: @baseMedia) {
                font-size: 19px;
            }
        }
    }
    .neworder__title {
        width: 100%;
        padding-top: 20px;
        padding-bottom: 20px;
        text-align: center;
        @media (max-width: @baseMedia) {
            padding-top: 10px;
            padding-bottom: 10px;
        }
        h1 {
            color: #4a4a4a;
            font-size: 30px;
            @media (max-width: @baseMedia) {
                font-size: 20px;
            }
        }
    }
    .neworder_margin {
        width: 95%;
        margin: 0 auto;
        padding-bottom: 20px;
        display: flex;
        justify-content: space-between;
        @media (max-width: @baseMedia) {
            justify-content: center;
            flex-wrap: wrap;
        }
        .neworder_margin_l {
            width: 40%;
            padding: 10px;
            @media (max-width: @baseMedia) {
                 width: 100%;
            }
            .neworder_margin_l_product {
                width: 100%;
                padding: 10px;
                border: 1px dotted #ccc;
                margin-bottom: 15px;
                display: flex;
                justify-content: flex-start;
                @media (max-width: @baseMedia) {
                    padding: 5px;
                    margin-bottom: 5px;
                }
                .neworder_margin_l_product_img {
                    width: 30%;
                    height: 90px;
                    overflow: hidden;
                    text-align: center;
                    @media (max-width: @baseMedia) {
                        height: 50px;
                    }
                    img {
                        height: 100%;
                    }
                }
                .neworder_margin_l_product_text {
                    width: 67%;
                    margin-left: 3%;
                    h4 {
                        font-size: 17px;
                        margin-bottom: 15px;
                        @media (max-width: @baseMedia) {
                            margin-bottom: 3px;
                            font-size: 13px;
                        }
                    }
                    p {
                        font-size: 17px;
                        @media (max-width: @baseMedia) {
                            font-size: 12px;
                        }
                    }
                }
            }
        }
        .neworder_margin_r {
            width: 60%;
            padding: 10px;
            @media (max-width: @baseMedia) {
                 width: 100%;
            }
            .neworder_margin_r_form {
                padding: 10px;
                border: 1px dotted #ccc;
                .bonuses_views {
                    width: 100%;
                    p {
                        @media (max-width: @baseMedia) {
                            font-size: 13px;
                            margin-bottom: 3px;
                        }
                    }
                }
                input {
                    width: 100%;
                    height: 40px;
                    border: 1px solid #ccc;
                    padding-left: 10px;
                    margin-bottom: 10px;
                    outline-color: #668800;
                }
                textarea {
                    width: 100%;
                    height: 100px;
                    resize: none;
                    border: 1px solid #ccc;
                    padding-left: 10px;
                    outline-color: #668800;
                    margin-bottom: 10px;
                    padding-top: 10px;
                }
                .error {
                    color: red;
                    font-size: 11px;
                }
                .errorText {
                    color: red;
                    font-size: 11px;
                    margin-top: 4px;
                } 
                select {
                    width: 100%;
                    padding: 10px;
                    border: 1px solid #ccc;
                    outline-color: #668800;
                    margin-bottom: 10px;
                }
                p {
                    margin-bottom: 10px;
                    font-size: 18px;
                }
                button {
                    width: 100%;
                    height: 40px;
                    outline: none;
                    text-transform: uppercase;
                    font-weight: bold;
                    border: none;
                    text-transform: uppercase;
                    color: white;
                    background: #3b5998;
                    @media (max-width: @baseMedia) {
                        font-size: 14px;
                    }
                    &:hover {
                        background: #254588;
                        transition: 1s;
                    }
                }
            }
        }
    }
}
</style>